/**
 * Handles API errors by checking the error response and throwing formatted messages.
 * This function determines whether the error is caused by a response, a request without a response,
 * or another type of error, and throws an appropriate error message.
 * 
 * @function
 * @param {Error} error - The error object thrown by Axios or another API call.
 * @throws {Error} - Throws a formatted error message based on the error type.
 * 
 * @example
 * try {
 *   // API call
 * } catch (error) {
 *   handleApiError(error);
 * }
 */
export const handleApiError = (error) => {

    if (!(error.response)) {
        throw new Error(error.message || "An unexpected error occurred");
    }

    const errorResponse = error.response.data;
    if (error.response) {
        // When the response is returned from the server with an error
        throw new Error(errorResponse.message || 'Request failed');
    } else if (error.request) {
        // When the request was made but no response was received
        throw new Error('No response from server');
    } else {
        // Any other errors (e.g., misconfigured request)
        throw new Error('An unexpected error occurred');
    }
};
